import CommonHelmet from '@src/components/CommonHelmet';
import BizsolIntroduction from '@src/features/company/auth/BizsolLoginForm';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyBizsolIntroduction() {
  return (
    <>
      <CompanyCenterCardLayout showCommonComponents>
        <CommonHelmet />
        <BizsolIntroduction />
      </CompanyCenterCardLayout>
    </>
  );
}

export default CompanyBizsolIntroduction;
